









import OptionalFeed from '@/component/view/OptionalFeed.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ContentService } from '@/kuroco_api';

@Component<MyPageLiked>({
  components: {
    OptionalFeed,
  },
})
export default class MyPageLiked extends Vue {}
